import { Outlet } from "react-router-dom"
const MainTimesheet = () =>{
    return(
        <div className=" w-full h-full">
         <Outlet/>
        </div>
    )
}


export default MainTimesheet;